// extracted by mini-css-extract-plugin
export default {"RelationshipsListAllView_ControlWrapper":"PaginatedRelationshipsListAllView-module__RelationshipsListAllView_ControlWrapper--SiKIY"};